import axios from "axios"

class GamesService {
  async getSchedule({ season, week }) {
    const games = []

    const scheduleResponse = await axios({
      method: "GET",
      url: `https://thefinalscores.com/api/?route=getSchedule&season=${season}&week=${week}`,
    })

    for (const game of scheduleResponse.data.data) {
      try {
        const predictionResponse = await axios({
          method: "GET",
          url: `https://thefinalscores.com/api/?route=doPrediction&eid=${game.eid}`,
        })

        const predictionString = predictionResponse.data
        const startIndex = predictionString.indexOf("{")

        games.push({
          ...game,
          ...JSON.parse(predictionString.substring(startIndex)),
        })
      } catch (error) {
        console.log(error.message)
      }
    }

    return games
  }
}

let gamesServiceInstance

function getGameServiceInstance() {
  if (!gamesServiceInstance) {
    gamesServiceInstance = new GamesService()
    return gamesServiceInstance
  } else if (gamesServiceInstance) {
    return gamesServiceInstance
  } else {
    return null
  }
}

export default getGameServiceInstance
